import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRespuesta, ApiRespuestaPaginada } from '@app/models/ApiRespuesta.interface';
import { Distrito } from '@app/models/distrito';
import { Empresa } from '@app/models/empresa';
import { Sector } from '@app/models/sector';
import { TipoVehiculo } from '@app/models/tipo-vehiculo';
import { Vehiculo } from '@app/models/vehiculo';
import { catchError, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { handleError } from '../tools/handle-error';

@Injectable({ providedIn: 'root' })
export class VehiculoService {
    private readonly http = inject(HttpClient);
    private readonly url = environment.url + 'vehiculo/';

    initForm() {
        const direction = this.url + 'initForm';
        return this.http
            .get<
                ApiRespuesta<{
                    sectores: Sector[];
                    distritos: Distrito[];
                    empresas: Empresa[];
                    tipos: TipoVehiculo[];
                    marcas: any;
                }>
            >(direction)
            .pipe(
                catchError((err) => handleError(err)),
                map((data) => data.result)
            );
    }

    getOne(id: string) {
        const url = this.url + id;
        return this.http.get<ApiRespuesta<Vehiculo>>(url).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    getAll(params?: HttpParams) {
        const direction = this.url + 'get/all';
        return this.http.get<ApiRespuestaPaginada<Vehiculo>>(direction, { params }).pipe(
            catchError((err) => handleError(err)),
            map((r) => r.result)
        );
    }

    create(payload: Partial<Vehiculo>) {
        return this.http.post<ApiRespuesta<Vehiculo>>(this.url, payload).pipe(
            catchError((err) => handleError(err)),
            map((r) => r.result ?? r)
        );
    }

    toggleActivo(id: string) {
        return this.http.post<ApiRespuesta<Vehiculo>>(`${this.url}toggle/activo/${id}`, null).pipe(
            catchError((err) => {
                throw new Error(err);
            }),
            map((data) => data.result)
        );
    }

    update(id: string, data: Partial<Omit<Vehiculo, 'id'>>) {
        return this.http.put<ApiRespuesta<Vehiculo>>(`${this.url}${id}`, data).pipe(
            catchError((err) => {
                throw new Error(err);
            }),
            map((data) => data.result)
        );
    }
}
